import { useEffect, useRef, useState } from "react";
import { subscribeToLiveAttendance } from "./liveAttendance";

// Subscribes to the live attendance stream for the signed-in user.
//
//   const { row, status } = useLiveAttendance();
//
// `row` is the latest day row pushed from the server (startTime/endTime/duration/
// status/punchCount), or null until the first punch arrives. `status` is
// "connecting" | "connected" | "reconnecting".
//
// Pass { enabled: false } to hold the connection closed, e.g. on a hidden tab.
export function useLiveAttendance({ enabled = true, onPunch } = {}) {
  const [row, setRow] = useState(null);
  const [status, setStatus] = useState("connecting");

  // kept in a ref so a new inline callback each render doesn't reopen the stream
  const onPunchRef = useRef(onPunch);
  onPunchRef.current = onPunch;

  useEffect(() => {
    if (!enabled) {
      setStatus("connecting");
      return undefined;
    }

    const stop = subscribeToLiveAttendance({
      onPunch: (punch) => {
        setRow(punch);
        if (onPunchRef.current) onPunchRef.current(punch);
      },
      onStatus: setStatus,
    });

    return stop;
  }, [enabled]);

  return { row, status };
}
